import store from '@/store'
export function UrlSearch () {
  let name, value, str = location.href, num = str.indexOf('?') // 取得整个地址栏
  console.log(str)
  var install = str.indexOf('install')
  var play = str.indexOf('rechargeOrder')

  var surl = {install: install, play: play}
  if (play > 0) {
    if (str.indexOf('orderId') > 0) {
      let order = str.lastIndexOf('orderId/'); let orderId = str.lastIndexOf('\/')
      surl.orderId = str.substring(order + 8, orderId)
    }
  }
  str = str.substr(num + 1) // 取得所有参数 stringvar.substr(start [, length ]
  let arr = str.split('&') // 各个参数放到数组里
  let UrlSearch = new Array()

  UrlSearch.push(surl)
  for (let i = 0; i < arr.length; i++) {
    num = arr[i].indexOf('=')

    if (num > 0) {
      name = arr[i].substring(0, num)
      value = arr[i].substr(num + 1)
      // this[name]=value;
      surl[name] = value
    }
  }
  UrlSearch.push(surl)
  console.log('11', UrlSearch[0])
  if (store.getters.urlSearch) {

  } else {
    store.dispatch('setHref', UrlSearch[0])
  }
  return UrlSearch[0]
}



// WEBPACK FOOTER //
// ./src/components/utils/UrlSearch.js